import { Permission } from '../interfaces';

export default function checkPermission(
  permissionCodeToCheck: string,
  allPermissions: Array<Permission>
): boolean {
  return allPermissions.some((permission) => permission.code === permissionCodeToCheck);
}
